module.exports = __webpack_public_path__ + "img/fabbi_logo.7d603879.jpeg";